<!--
 * @Descripttion:
 * @version: 1.0
 * @Author: qiye
 * @Date: 2019-10-28 13:52:33
 * @LastEditors: qiye
 * @LastEditTime: 2021-09-07 14:19:21
 -->
<template>
  <div>
    <div id="tbox" style="z-index:9999;">
    <div class="qq_Toggle">
        <ul class="right-suspension">
        	<li class="right-online">
        		<a href="http://pht.zoosnet.net/LR/Chatpre.aspx?id=PHT48630383&lng=cn" target="_blank"></a>
        	</li>
            <li class="right-phone">
                <div class="phone-hide">
                	<dl>
                      <dt>业务销售</dt>

                      <dd>
                      	<p>张经理</p>
                      	<div>
	                      	<i><img src="http://static.yunbiao.tv/imgserver/static//css/front/images/icon-phone.png" alt=""></i>
	                      	<a href="tel:15810423514" title="张经理">15810423514</a>
	                      	<!-- <a href="tencent://message/?uin=3003455963" title="何经理">
	                      		<img src="http://static.yunbiao.tv/imgserver/static//css/front/images//icon-qq.png" alt="">
	                      	</a> -->
                      	</div>
											</dd>

                   </dl>
                </div>
            </li>
            <li class="right-service">
                <div class="service-hide">
                	<dl>
                      <dt style="font-size: 18px;">售后咨询</dt>
                      <dt>软件售后</dt>
											<dd style="border-bottom:none;">
                      	<div>
	                      	<i><img src="http://static.yunbiao.tv/imgserver/static//css/front/images/icon-phone.png" alt=""></i>
	                      	<p>吴先生</p>
	                      	<a href="tel:15601090351" title="吴先生">15601090351</a>
                      	</div>
                      </dd>
                      <dd >
                      	<div>
	                      	<i><img src="http://static.yunbiao.tv/imgserver/static//css/front/images/icon-phone.png" alt=""></i>
	                      	<p>王经理</p>
	                      	<a href="tel:18933937366" title="王经理">18933937366</a>
                      	</div>
                      </dd>

                      
                   </dl>
                </div>
            </li>
            <li class="qr-code" @click='qrCode()'>
                <div class="code-hide">
                	<h5><a id="xwy" href="http://www.yunbiao.tv/background/login.html" target="_blank" title="云平台登录">云平台登录</a></h5>
                	<span>云控下载</span>
                	<a href="http://www.yunbiao.tv/softskp.html" targer="_blank"><img src="http://www.yunbiao.tv/ybservice/open/qcore/getQcore.htm?content=http://www.yunbiao.tv//web/softskp.html&amp;height=400&amp;width=400" title="商显行业最早开发云平台，独家拥有手机云控app"></a>
                </div>
            </li>
            <li class="backtop">
                <a href="#"></a>
            </li>
        </ul>
    </div>
    <!-------------------------------新版左侧固定-------------------------------->
  </div>
  </div>
</template>
<script>
export default {
	data(){
		return{

		}
	},
	methods:{
		qrCode(){
			window.open(
        "http://www.yunbiao.tv/background/login.html",
        "_blank"
      );
		}
	}
}
</script>
<style lang="stylus" scoped>
#tbox {
    width: auto;
    float: right;
    position: fixed;
    right: 10px;
    top: 350px;
    z-index: 9999;
}
/*qq*/
#tbox {
    width: 80px;
    float: right;
    position: fixed;
    right: 0px;
    top: 310px;
    z-index: 9999;
}
#tbox li{
	padding:0;
}
.right-suspension{
	float:right
}
.right-suspension li>a{
	display:block;
	width: 61px;
    height: 66px;
}

.right-suspension .right-online,.right-phone,.right-service,.qr-code,.backtop {
    width: 70px;
    height: 66px;
    background: url('./images/qq.png') no-repeat;
    display: block !important;
    box-sizing:border-box;
}
.right-suspension .right-online{
    background-position: 10px -1px;
}

.right-suspension .right-phone {
    background-position: 10px -67px;
}
.right-suspension .right-service {
    background-position: 10px -133px;
}
.right-suspension .qr-code {
    background-position: 10px -199px;
}

.right-suspension .backtop{
    background-position: 10px -265px;
}
.right-suspension .right-phone:hover .phone-hide{
	display:block;
}
.phone-hide{
	position:absolute;
	right:70px;
	background:#109ece;
	color:#fff;
	border-radius:10px;
	padding:10px;
	box-sizing:border-box;
	display:none;

}
.phone-hide dt{
	text-align:center;
	margin-bottom:5px;
}
.phone-hide dd{
	border-bottom:1px solid #fff;
	margin-bottom:5px;
}
.phone-hide dd:last-child{
	border-bottom:none;
}
.phone-hide dd div{
	display:flex;
	justify-content:space-between;
	align-items:center;
	padding:5px 0;
}
.phone-hide dd div>a{
	color:#fff;
	margin:0 5px;
	text-decoration:none
}
.right-suspension .right-service:hover .service-hide{
	display:block;
}
.service-hide{
	position:absolute;
	right:70px;
	background:#109ece;
	color:#fff;
	border-radius:10px;
	padding:10px;
	box-sizing:border-box;
	width: 174px;
	display:none;

}
.service-hide dt{
	text-align:center;
	margin-bottom:5px;
}
.service-hide dd{
	border-bottom:1px solid #fff;
	margin-bottom:5px;
}
.service-hide dd:last-child{
	border-bottom:none;
}
.service-hide dd div{
	display:flex;
	justify-content:flex-start;
	align-items:center;
	padding:5px 0;
}
.service-hide dd div>a{
	color:#fff;
	margin:0 5px;
	text-decoration:none
}
.right-suspension .qr-code:hover .code-hide{
	display:block;
}
.code-hide{
	position:absolute;
	right:70px;
	background:#109ece;
	color:#fff;
	border-radius:10px;
	padding:10px;
	box-sizing:border-box;
	display:none;
}
.code-hide h5{
	font-size:18px;
	text-align:center;
	margin-bottom:10px;
}
.code-hide span{
	display:block;
	text-align:center;
}
.code-hide h5 a{
	font-weight:bold;
	color:#fff;
}
.code-hide img{
	width:100px;
	border-radius:15px;
	margin-top:10px;
}


</style>



// WEBPACK FOOTER //
// src/components/common/sidebar.vue